import { SYSTEM_VARIABLE_CATALOG } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariables.utils';
const DEFAULT_DYNAMIC_FIELD_CATEGORY = 'This notification';
export const enrichDynamicFields = (templateVariables)=>Object.entries(templateVariables).map((param)=>{
        let [field, sample] = param;
        var _ref;
        const catalogEntry = SYSTEM_VARIABLE_CATALOG.find((entry)=>entry.key === field);
        return {
            field,
            sample,
            category: (_ref = catalogEntry === null || catalogEntry === void 0 ? void 0 : catalogEntry.category) !== null && _ref !== void 0 ? _ref : DEFAULT_DYNAMIC_FIELD_CATEGORY
        };
    });
export const adaptNotificationRewriteResponse = (response)=>{
    if (response.type === 'clarification') {
        return {
            canUndo: false,
            isClarification: true,
            conversationId: response.conversationId,
            output: null,
            clarificationText: response.text
        };
    }
    return {
        canUndo: response.canUndo,
        isClarification: false,
        conversationId: response.conversationId,
        output: response,
        clarificationText: null
    };
};
